.maintenance-windows-sidenav {
  .maintenance-windows-sidenav--body {
    cursor: default;
    border-top: 1px solid var(--chart-101-pressed-dividers);

    .title {
      padding: calc(var(--spacer) + 1px) calc(var(--spacer) * 2);
      color: var(--chart-302-icon-buttons-titles);
      line-height: calc(var(--body-size) - 1px);
      min-height: calc(var(--spacer) * 4);
      margin-top: var(--spacer);
    }

    gz-list-item {
      padding-left: calc(var(--spacer) * 2);
      color: var(--main-titles-inputs-600);
      line-height: var(--body-size);
      border-radius: calc(var(--spacer) / 2);
    }
  }
}
